define((require) => {
    "use strict";

    const ImageLibrarySourceEnum = require("shared/data/images/ImageLibrarySourceEnum");
    const IntegrationModel       = require("editor/ui/settings/integrations/IntegrationModel");
    const Scene7HostedRegionEnum = require("editor/ui/settings/integrations/Scene7HostedRegionEnum");

    const {
        UNAUTHORIZED,
        SERVICE_UNAVAILABLE
    } = require("shared/util/HttpStatusCodes");

    const TYPE_NAME = ImageLibrarySourceEnum.SCENE7.name;

    /**
     * Custom error messages for `401` and `503`.
     *
     * Status codes mapped to error messages.
     *
     * @type Map.<Number, String>
     */
    const errorMessages = new Map();
    errorMessages.set(UNAUTHORIZED, "The Adobe credentials you entered are invalid.");
    errorMessages.set(SERVICE_UNAVAILABLE, "Creator was unable to communicate with Adobe Scene7.");

    return IntegrationModel.extend("Scene7Integration", {
        defaults: {
            username: "",
            password: "",
            type: TYPE_NAME, // other integrations created in Zelp already have this supplied from the backend
            companyName: "",
            region: Scene7HostedRegionEnum.NA.value
        },

        // Added in order to get the image serving url right after initial save.
        updateOnSync: ["imageServingUrl"],

        validate(attrs) {
            if (!attrs.username) {
                return "A username must be filled in to save this integration";
            }

            if (!attrs.password) {
                return "A password must be filled in to save this integration";
            }
        },

        _handleError(error, options) {
            const {status} = error;

            // Handle custom error messages...
            if (errorMessages.has(status)) {
                error.action = "";
                error.prefix = "";
                error.message = errorMessages.get(status);
                options.closeDelay = 7000;

                return "alert";
            }

            return this.__super();
        }

    }, {
        type: TYPE_NAME
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/Scene7IntegrationModel.js